import { render, staticRenderFns } from "./ai.vue?vue&type=template&id=42bc0804&scoped=true"
var script = {}
import style0 from "./ai.vue?vue&type=style&index=0&id=42bc0804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bc0804",
  null
  
)

export default component.exports